// extracted by mini-css-extract-plugin
module.exports = {"ac-icon__wishlist--loading":"_2AdCk","ac-icon__wishlist-dash":"W1dnB"};